export var UPDATE_ISAUTHENTICATED = 'UPDATE_ISAUTHENTICATED';
export var UPDATE_ISCANCEL = 'UPDATE_ISCANCEL';
export var UPDATE_ISPHONENUMBER = 'UPDATE_ISPHONENUMBER';
export var UPDATE_LANGUAGECODE = 'UPDATE_LANGUAGECODE';
export var UPDATE_ERROR_CONTAINER = 'UPDATE_ERROR_CONTAINER';
export var UPDATE_ISAUTHENTICATEDUI = 'UPDATE_ISAUTHENTICATEDUI';
export var UPDATE_PAYLOAD = 'UPDATE_PAYLOAD';
export var RESET = 'RESET';
export var UPDATE_HASANALYTICS = 'UPDATE_HASANALYTICS';
export var UPDATE_ANALYTICS = 'UPDATE_ANALYTICS';
export var UPDATE_SFFDL = 'UPDATE_SFFDL';
export var UPDATE_CONFIG = 'UPDATE_CONFIG';
export var UPDATE_PARAMS = 'UPDATE_PARAMS';
export var UPDATE_ALTERNATEFLOWCLICKED = 'UPDATE_ALTERNATEFLOWCLICKED';
export var UPDATE_TRUSTSCORERETRYCOUNT = 'UPDATE_TRUSTSCORERETRYCOUNT';
export var UPDATE_TRUSTSCOREERRORCONTAINER = 'UPDATE_TRUSTSCOREERRORCONTAINER';
export var UPDATE_IS_LOADING = 'UPDATE_IS_LOADING';
export var UPDATE_TRUST_SCORE_ACTION = 'UPDATE_TRUST_SCORE_ACTION';
